import React from 'react';
import { X } from 'lucide-react';

const Row = ({ label, value }) => (
    <div className="flex justify-between items-center py-3 border-b border-gray-100 last:border-0">
        <span className="text-sm text-gray-400">{label}</span>
        <span className="text-sm font-semibold text-gray-800 text-right max-w-[60%]">{value}</span>
    </div>
);

const ViewDetailsModal = ({ booking, onClose }) => (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-end sm:items-center justify-center z-50 p-4">
        <div className="bg-white rounded-2xl w-full max-w-sm shadow-xl overflow-hidden">

            {/* Header */}
            <div className="bg-indigo-700 px-5 py-4 flex items-center justify-between">
                <div>
                    <h3 className="text-white font-bold text-base">Appointment Details</h3>
                    <p className="text-indigo-200 text-xs mt-0.5 truncate">{booking.clinicName}</p>
                </div>
                <button
                    onClick={onClose}
                    className="w-8 h-8 bg-white bg-opacity-20 rounded-full flex items-center justify-center hover:bg-opacity-30 transition-all flex-shrink-0 ml-3"
                >
                    <X className="w-4 h-4 text-white" />
                </button>
            </div>

            {/* Body */}
            <div className="px-5 pb-5 pt-1">
                <Row label="Clinic" value={booking.clinicName} />
                <Row label="City" value={booking.city || '—'} />
                <Row label="Member" value={booking.memberName} />
                <Row label="Date" value={booking.date} />
                <Row label="Time" value={booking.time} />
                <Row label="Status" value={booking.status} />

                <button
                    onClick={onClose}
                    className="mt-4 w-full py-3 text-sm font-semibold text-indigo-600 bg-white border border-indigo-300 hover:bg-indigo-50 rounded-xl transition-colors"
                >
                    Close
                </button>
            </div>
        </div>
    </div>
);

export default ViewDetailsModal;
